// extracted by mini-css-extract-plugin
export default {"root":"PrivateModal_root__SsYxA"};